import GeoSectorSearch from "./GeoSectorSearch";
import GeoPolylineArrow from "./GeoPolylineArrow";
import GeoTriFlag from "./GeoTriFlag";
import GeoCurveArrow from "./GeoCurveArrow";
import GeoDoubleArrow from "./GeoDoubleArrow";
import GeoRectangle from "./GeoRectangle";
import GeoRectangle2 from "./GeoRectangle2";
import GeoCircle from "./GeoCircle";
import GeoCircle2 from "./GeoCircle2";
import GeoPolygon from "./GeoPolygon";
import GeoPin from "./GeoPin";
import GeoRightAngleFlag from "./GeoRightAngleFlag";
import GeoCurveFlag from "./GeoCurveFlag";
import GeoPolyline from "./GeoPolyline";
import GeoArc from "./GeoArc";
import GeoBezier2 from "./GeoBezier2";
import GeoBezier3 from "./GeoBezier3";
import GeoSector from "./GeoSector";
import GeoSector2 from "./GeoSector2";
import GeoParallelSearch from "./GeoParallelSearch";
import GeoCurve from "./GeoCurve";


XE.Obj.Plots = XE.Obj.Plots || {};

XE.Obj.Plots.GeoSectorSearch = GeoSectorSearch;
XE.Obj.Plots.GeoPolylineArrow = GeoPolylineArrow;
XE.Obj.Plots.GeoTriFlag = GeoTriFlag;
XE.Obj.Plots.GeoCurveArrow = GeoCurveArrow;
XE.Obj.Plots.GeoDoubleArrow = GeoDoubleArrow;
XE.Obj.Plots.GeoRectangle = GeoRectangle;
XE.Obj.Plots.GeoRectangle2 = GeoRectangle2;
XE.Obj.Plots.GeoCircle = GeoCircle;
XE.Obj.Plots.GeoCircle2 = GeoCircle2;
XE.Obj.Plots.GeoPolygon = GeoPolygon;
XE.Obj.Plots.GeoPin = GeoPin;
XE.Obj.Plots.GeoRightAngleFlag = GeoRightAngleFlag;
XE.Obj.Plots.GeoCurveFlag = GeoCurveFlag;
XE.Obj.Plots.GeoPolyline = GeoPolyline;
XE.Obj.Plots.GeoArc = GeoArc;
XE.Obj.Plots.GeoBezier2 = GeoBezier2;
XE.Obj.Plots.GeoBezier3 = GeoBezier3;
XE.Obj.Plots.GeoSector = GeoSector;
XE.Obj.Plots.GeoSector2 = GeoSector2;
XE.Obj.Plots.GeoParallelSearch = GeoParallelSearch;
XE.Obj.Plots.GeoCurve = GeoCurve;